var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2766_13866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66186 13.3137H9.93554C10.9892 13.3137 11.8513 14.1758 11.8513 15.2295V24.8083C11.8513 25.862 10.9892 26.724 9.93554 26.724H9.66186C8.60819 26.724 7.74609 25.862 7.74609 24.8083V15.2295C7.74609 14.1758 8.60819 13.3137 9.66186 13.3137ZM17.3249 7.56641C18.3786 7.56641 19.2407 8.4285 19.2407 9.48217V24.8083C19.2407 25.862 18.3786 26.724 17.3249 26.724C16.2712 26.724 15.4092 25.862 15.4092 24.8083V9.48217C15.4092 8.4285 16.2712 7.56641 17.3249 7.56641ZM24.988 18.5136C26.0416 18.5136 26.9037 19.3757 26.9037 20.4294V24.8083C26.9037 25.862 26.0416 26.724 24.988 26.724C23.9343 26.724 23.0722 25.862 23.0722 24.8083V20.4294C23.0722 19.3757 23.9343 18.5136 24.988 18.5136Z",
    fill: "#4318FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2766_13866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.8417,
    height: 32.8417,
    fill: "white",
    transform: "translate(0.902344 0.724609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.7d459b6d21fc3e25517057b56db9ece4.svg";
export { ForwardRef as ReactComponent };